import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-form-template',
    template: `
        <h2>This is example of form elements!</h2>
        <form [formGroup]="myForm" (ngSubmit)="submit()" novalidate>
            <div class="row">
                <div class="col-4">
                    <h3>Inputs</h3>
                    <app-form-input formControlName="username"
                                    placeholder="Your name"></app-form-input>
                    <app-form-input formControlName="email"
                                    type="email"
                                    placeholder="Email"
                                    [disabled]="true"></app-form-input>
                    <app-form-input formControlName="password"
                                    type="password"
                                    placeholder="Password"></app-form-input>
                    <app-form-input formControlName="passwordConfirmation"
                                    type="password"
                                    placeholder="Password Repeat"></app-form-input>
                </div>
                <div class="col-4">
                    <h3>Textareas & selects</h3>
                    <app-form-select formControlName="securityQuestion"
                                     placeholder="Security Question"
                                     [options]="questions"
                                     title="Question"></app-form-select>
                    <app-form-textarea formControlName="securityAnswer"
                                       placeholder="Security Answer"
                                       title="Answer"
                                       rows="4"></app-form-textarea>
                    <div class="form-input-width-select-wrapper">
                        <app-form-input formControlName="depositSum"
                                        type="number"
                                        placeholder="Deposit sum"></app-form-input>
                        <app-form-select formControlName="depositCurrency"
                                         placeholder="Deposit currency"
                                         [options]="currencies"></app-form-select>
                    </div>
                </div>
                <div class="col-4">
                    <h3>Checkboxes, radios, switches</h3>
                    <app-form-checkbox formControlName="agree"
                                       label="I agree with T&Cs"
                                       title="Terms and conditions"></app-form-checkbox>
                    <app-form-radio formControlName="gender"
                                    value="male"
                                    label="Male"
                                    name="gender"
                                    title="Choose your gender"></app-form-radio>
                    <app-form-radio formControlName="gender"
                                    value="female"
                                    name="gender"
                                    label="Female"></app-form-radio>
                    <app-form-switch formControlName="ageVerify"
                                     label="I am over 18 years old"
                                     title="Terms and conditions"></app-form-switch>
                </div>
            </div>
            <br>
            <br>
            <div class="row">
                <div class="col-12">
                    <h3>Buttons</h3>
                    <app-form-button type="submit">Confirm full width</app-form-button>
                    <app-form-button class="default">Default</app-form-button>
                    <app-form-button class="default" [disabled]="true">Default disabled</app-form-button>
                    <app-form-button icon="fa fa-check">Confirm with icon</app-form-button>
                    <app-form-button icon="fa fa-check" icon-position="right">Confirm with icon on the right
                    </app-form-button>
                    <app-form-button class="icon primary"><i class="fa fa-check"></i></app-form-button>
                    <app-form-button>Confirm</app-form-button>
                    <app-form-button class="primary">Primary</app-form-button>
                    <app-form-button class="danger">Danger</app-form-button>
                    <app-form-button icon="fa fa-check" [loading]="true">Confirm with icon</app-form-button>
                    <app-form-button [loading]="true" class="primary">Primary with loading</app-form-button>
                    <app-form-button [loading]="true" class="danger">Danger with loading</app-form-button>
                    <app-form-button [loading]="true" class="default full-width">Default full width with
                        loading
                    </app-form-button>
                </div>
            </div>
        </form>
    `,
    styleUrls: ['./form.template.scss']
})
export class FormTemplateComponent implements OnInit {

    myForm: FormGroup;
    questions: any = [
        {
            option: 'fav_lesson',
            value: 'Best lesson?'
        },
        {
            option: 'fav_teacher',
            value: 'What was your hottest teacher?'
        },
        {
            option: 'fav_shop',
            value: 'What is your favorite shopping center?'
        },
    ];
    currencies: any = [
        {
            option: 'edg',
            value: 'EDG',
            icon: 'fa fa-times',
        },
        {
            option: 'eth',
            value: 'ETH',
            icon: 'fa fa-caret-down',
        },
        {
            option: 'btc',
            value: 'BTC',
            icon: 'fa fa-user',
        },
        {
            option: 'mkc',
            value: 'MIK1C',
            icon: 'fa fa-user',
        },
    ];

    constructor(private formBuilder: FormBuilder) {
    }

    ngOnInit() {
        this.myForm = this.formBuilder.group({
            username: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.minLength(7), Validators.required]],
            passwordConfirmation: ['', [Validators.required]],
            securityQuestion: ['', Validators.required],
            securityAnswer: ['', Validators.required],
            agree: [false, Validators.requiredTrue],
            gender: [null, Validators.required],
            depositSum: [0, [Validators.min(5), Validators.max(1000)]],
            depositCurrency: ['edg', Validators.required],
            ageVerify: [false, Validators.requiredTrue],
        }, {
            validator: (AC: AbstractControl): void => {
                const password = AC.get('password').value;
                const confirmPassword = AC.get('passwordConfirmation').value;
                if (password !== confirmPassword) {
                    AC.get('passwordConfirmation').setErrors({MatchPassword: true});
                } else {
                    return null;
                }
            }
        });
    }

    submit() {
        if (!this.myForm.valid) {
            this.validateAllFormFields(this.myForm);
        }
    }

    validateAllFormFields(formGroup: FormGroup) {         //{1}
        Object.keys(formGroup.controls).forEach(field => {  //{2}
            const control = formGroup.get(field);             //{3}
            if (control instanceof FormControl) {             //{4}
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {        //{5}
                this.validateAllFormFields(control);            //{6}
            }
        });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/form-template.component.ts